import {createElement, Fragment} from "react";

const Condition = ({ children, match }) => {
	if (match) {
		return createElement(Fragment, {}, children);
	}

	return null;
};

export default Condition;
